/** @jsxImportSource @emotion/react */
import React, { ReactNode } from 'react';
import { selectedValueStyles } from './selected-value.styles';
import closeIcon from '../../../../../assets/icons/close-icon.svg';

type Props = {
    value: string;
    onRemove?: () => void;
    onSelect?: () => void;
    isSelected?: boolean;
    icon?: ReactNode;
    isQuickFilter?: boolean;
};

const SelectedValue = (props: Props) => {
    const { value, onRemove, onSelect, isSelected = true, icon, isQuickFilter = false } = props;
    const handleClick = isSelected ? onRemove : onSelect;

    return (
        <span
            onClick={handleClick}
            css={[
                selectedValueStyles.root,
                !isSelected ? selectedValueStyles.unselected : null,
                isQuickFilter ? selectedValueStyles.quickFilter : null,
                onRemove && isSelected ? selectedValueStyles.quickFilterSelected : null,
            ]}>
            <div css={selectedValueStyles.innerContainer}>
                {icon}
                <span>{value}</span>
            </div>
            {onRemove && isSelected && (
                <img css={selectedValueStyles.closeIcon} src={closeIcon} alt="close" />
            )}
        </span>
    );
};

export default SelectedValue;
